import React from 'react';
import Icon from '../../Icon';
import { C } from '../../../utils/styles';

function fmt$(n) {
  return `$${Math.round(Number(n) || 0).toLocaleString()}`;
}
function fmtPct(n) {
  const v = (Number(n) || 0) * 100;
  const sign = v >= 0 ? '+' : '';
  return `${sign}${v.toFixed(2)}%`;
}

const STATUS = {
  good: { color: C.green, bg: C.greenLight, icon: 'checkmark-circle', label: 'Match' },
  warn: { color: C.orange, bg: C.orangeLight, icon: 'warning-outline', label: 'Slight variance' },
  high: { color: C.red, bg: '#fee2e2', icon: 'alert-circle', label: 'High variance' },
};

export default function CalculationValidationPanel({ validation, hide }) {
  if (!validation || hide) return null;
  const s = STATUS[validation.overall] || STATUS.good;
  return (
    <div data-testid="smart-upload-validation-panel" style={{
      background: '#fff', border: `1px solid ${C.border}`, borderRadius: 12, padding: 24, marginBottom: 16,
    }}>
      <div style={{ display: 'flex', alignItems: 'start', gap: 12, marginBottom: 16 }}>
        <div style={{
          width: 36, height: 36, borderRadius: 8, background: s.bg, color: s.color,
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          <Icon name={s.icon} style={{ fontSize: 20 }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>
            Calculation Validation
          </div>
          <div style={{ fontSize: 13, color: C.textMid, lineHeight: 1.5 }}>
            We compared our calculations against the actual employer taxes in your source data.
          </div>
        </div>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: C.bg, borderBottom: `2px solid ${C.border}` }}>
              <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600 }}>Tax</th>
              <th style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>Actual paid</th>
              <th style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>Our calc</th>
              <th style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 600 }}>Variance</th>
              <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {validation.lines.map((line) => {
              const ls = STATUS[line.status] || STATUS.good;
              return (
                <tr key={line.key} data-testid={`validation-row-${line.key}`} style={{ borderBottom: `1px solid ${C.borderLight}` }}>
                  <td style={{ padding: '10px 12px', fontWeight: 600 }}>{line.label}</td>
                  <td style={{ padding: '10px 12px', textAlign: 'right' }}>{fmt$(line.actual)}</td>
                  <td style={{ padding: '10px 12px', textAlign: 'right' }}>{fmt$(line.calc)}</td>
                  <td style={{ padding: '10px 12px', textAlign: 'right', color: ls.color, fontWeight: 600 }}>{fmtPct(line.variance)}</td>
                  <td style={{ padding: '10px 12px' }}>
                    <span style={{
                      display: 'inline-flex', alignItems: 'center', gap: 4,
                      padding: '3px 10px', borderRadius: 999, background: ls.bg, color: ls.color,
                      fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4,
                    }}>
                      <Icon name={ls.icon} style={{ fontSize: 12 }} />
                      {ls.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div style={{
        marginTop: 16, padding: 12, borderRadius: 8, background: s.bg, color: s.color,
        fontSize: 13, lineHeight: 1.5,
      }}>
        {validation.overall === 'good' && (
          <span><strong>All variances under 0.5%</strong> — calculations match actual taxes paid. Confidence level: <strong>High — analysis based on validated data.</strong></span>
        )}
        {validation.overall === 'warn' && (
          <span>Some variances are between 0.5% and 2%. This is normal precision (employees crossing the SS wage base mid-year, partial-period data).</span>
        )}
        {validation.overall === 'high' && (
          <span><strong>Variance above 2% detected — please verify.</strong> Possible causes: incorrect wage-base year, mid-year hires, or partial-year data.</span>
        )}
      </div>
    </div>
  );
}
